import React from 'react';
import PropTypes from 'prop-types';
import Notification from 'erpcore/components/Notification';

/**
 * Notification Manager - Roles and Permissions Notifications
 * @return {Node} Returns Notification component
 */
// eslint-disable-next-line no-unused-vars
const GuidelinesNotifications = ({ identifier, code, detail, notificationData }) => {
    switch (code) {
        case 'guideline.itemSuccessfulyCreated':
            return (
                <Notification
                    identifier={identifier}
                    title="Success"
                    text="Event Guideline successfully created!"
                    type="success"
                    expire="3500"
                />
            );
        case 'guideline.itemSuccessfulyUpdated':
            return (
                <Notification
                    identifier={identifier}
                    title="Success"
                    text="Event Guideline successfully updated!"
                    type="success"
                    expire="3500"
                />
            );
        case 'guideline.itemSuccessfulyRemoved':
            return (
                <Notification
                    identifier={identifier}
                    title="Success"
                    text="Event Guideline successfully deleted!"
                    type="success"
                    expire="3500"
                />
            );
        default:
            return null;
    }
};

GuidelinesNotifications.defaultProps = {
    identifier: null,
    code: null,
    detail: null,
    notificationData: null
};

GuidelinesNotifications.propTypes = {
    identifier: PropTypes.string,
    code: PropTypes.string,
    detail: PropTypes.string,
    notificationData: PropTypes.oneOfType([PropTypes.string, PropTypes.object, PropTypes.array])
};

export default GuidelinesNotifications;
